import script from "./delivery-service.vue?vue&type=script&lang=ts&setup=true"
export * from "./delivery-service.vue?vue&type=script&lang=ts&setup=true"

import "./delivery-service.vue?vue&type=style&index=0&id=dc612bb8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc612bb8"]])

export default __exports__